import CustomValuesHook from "../../../../Hooks/customValuesHook"
import { IData } from "../../../../api/modelAPI/detectedSensitiveWordLog"

type Props = {
    item: IData,
    changeStatus: Function,
    loading: boolean,
    setStates:Function
}

const RequsetPendingReason = ({ item, changeStatus, loading ,setStates}: Props) => {


    const [value, setValue] = CustomValuesHook({
        text: ''
    })

    const change = (e: any) => {
        e.preventDefault()
        let obj = {
            id: item?.id,
            state: "InvestigationPending",
            description: value?.text

        }
        changeStatus(obj)
    }

    return (
        <div className="request-pending">
            <div className="d-flex flex-column justify-content-start align-items-start">
                <label>آیا این مشترک به زمان بیشتری برای بررسی نیاز دارد؟</label>
                <label>توضیح:</label>
                <textarea value={value?.text} onChange={(e) => setValue({ text: e.target.value })} />

            </div>
            <div className="d-flex justify-content-center align-items-center mt-3">
                <div className="d-flex justify-content-between align-items-center footer-wrpper">
                    <button className="btn btn-default" onClick={() => setStates({ show: false })}>انصراف</button>
                    <button className="btn btn-primary" onClick={(e) => change(e)} >{
                        loading?
                        <div className="spinner-border" role="status" aria-hidden="true"></div>:
                        'بله'

                    }</button>
                </div>

            </div>
        </div>
    )
}

export default RequsetPendingReason